import supabase from "../utils/supabase";

const TABLE_NAME = "customers";

export interface Customer {
  id: string;
  full_name: string;
  email: string;
  phone_country_code: string;
  phone_number: string;
  country_of_citizenship: string;
  country_of_residence: string;
  canadian_status: string;
  service_reason: string;
  status: string;
  agree_to_terms: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateCustomerData {
  full_name: string;
  email: string;
  phone_country_code?: string;
  phone_number?: string;
  country_of_citizenship?: string;
  country_of_residence?: string;
  canadian_status?: string;
  service_reason?: string;
  agree_to_terms: boolean;
}

export const getCustomers = async (): Promise<Customer[]> => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select("*")
    .order("updated_at", { ascending: false });

  if (error) {
    throw error;
  }

  return data || [];
};

export const createCustomer = async (
  customerData: CreateCustomerData
): Promise<Customer> => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert({
      ...customerData,
      status: "Unprocessed", // Default status
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateCustomerStatus = async (
  customerId: string,
  status: string
): Promise<Customer> => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update({
      status,
      updated_at: new Date().toISOString(),
    })
    .eq("id", customerId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteCustomer = async (customerId: string): Promise<void> => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq("id", customerId);

  if (error) {
    throw error;
  }
};
